import {
    SignUpForm,
    SignUpFormWithPopover,
    type SignUpFormArgs,
} from "./SignUpForm";

export default SignUpFormWithPopover;

export { SignUpForm, SignUpFormWithPopover, type SignUpFormArgs };
